import { NgModule } from '@angular/core';
import {SearchComponent} from './search.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {DialogModule} from '../dialog/dialog.module';

@NgModule({
  declarations: [
      SearchComponent
  ],
    imports: [
        MatFormFieldModule,
        FormsModule,
        MatTooltipModule,
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        DialogModule
    ],
  exports: [
      SearchComponent
  ]
})
export class SearchModule { }
